/**
 * Orchestra AI Platform - Input Node Component
 * 
 * Custom node component for workflow input parameters
 * 
 * @fileoverview Input node for workflow entry point
 */

import { Handle, Position } from 'reactflow';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} InputNodeData
 * @property {string} id
 * @property {string} label
 * @property {Object} parameters
 */

/**
 * Input Node Component
 * @param {Object} props
 * @param {InputNodeData} props.data
 * @param {boolean} props.selected
 */
export function InputNode({ data, selected }) {
  return (
    <div
      className={`input-node bg-green-50 rounded-lg shadow-md border-2 p-3 min-w-[150px] ${
        selected ? 'border-green-500' : 'border-green-200'
      }`}
    >
      <div className="node-header mb-2">
        <span className="px-2 py-1 text-xs font-semibold text-white bg-green-500 rounded">
          Input
        </span>
      </div>

      <div className="node-body">
        <h3 className="font-semibold text-sm">{data.label || 'Workflow Input'}</h3>
        {data.parameters && Object.keys(data.parameters).length > 0 && (
          <div className="mt-2 text-xs text-gray-600">
            {Object.keys(data.parameters).length} parameter(s)
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Right} className="w-3 h-3" />
    </div>
  );
}

InputNode.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    parameters: PropTypes.object,
  }).isRequired,
  selected: PropTypes.bool,
};

